// extracted by mini-css-extract-plugin
export default {"cardContainer":"cardStyles_cardContainer__f7Aok"};